module.exports = __webpack_public_path__ + "media/images/Kitchen Cabinets-feeb2d4d.webp";